<template>
    <footer class="main_wrapper">
        <div class="wrapper">
            <div class="container">
                <div class="block_l1 block_l1_super">
                    <div class="block_icon">
                        <!-- <img
                            src="../../assets/footer/TVCOM_icon_footer.png"
                            alt="Tvcom"
                            class="block_icon_img"
                        /> -->
                        <div class="block_icon_img" @click="handleTestAccount">
                            <Logo />
                        </div>
                    </div>

                    <div class="block_social">
                        <ElLink
                            href="https://www.facebook.com/tvcom.uz/"
                            tag="a"
                            size="small"
                            circle
                            :attrs="{
                                target: '_blank',
                                rel: 'noopener noreferrer',
                                'aria-label': 'facebook',
                            }"
                            type="grey"
                        >
                            <IconFb />
                        </ElLink>
                        <ElLink
                            href="https://t.me/tvcom_uz"
                            tag="a"
                            size="small"
                            circle
                            :attrs="{
                                target: '_blank',
                                rel: 'noopener noreferrer',
                                'aria-label': 'telegram',
                            }"
                            type="grey"
                        >
                            <IconTg />
                        </ElLink>
                        <ElLink
                            href="https://www.instagram.com/tvcom.uz_official"
                            tag="a"
                            size="small"
                            circle
                            :attrs="{
                                target: '_blank',
                                rel: 'noopener noreferrer',
                                'aria-label': 'instagram',
                            }"
                            type="grey"
                        >
                            <IconInst />
                        </ElLink>
                        <ElLink
                            href="https://ok.ru/group/55898902429839"
                            tag="a"
                            size="small"
                            circle
                            :attrs="{
                                target: '_blank',
                                rel: 'noopener noreferrer',
                                'aria-label': 'ok',
                            }"
                            type="grey"
                        >
                            <IconOk />
                        </ElLink>
                    </div>
                    <div class="block_phone">
                        <a class="phone_text" href="tel:+998712058555"
                            >71 205 85 55</a
                        >
                    </div>
                    <div c lass="block_info">
                        <span
                            >© {{ new Date().getFullYear() }} ООО
                            "TVPLUS".</span
                        >
                        <p class="block_info_text">
                            <a
                                class="doc_link"
                                href="/policy"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {{ $t("message.privacyPolicy") }} <br />
                            </a>
                            <a
                                class="doc_link"
                                href=" http://tvcom.uz/documents/oferta.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {{ $t("message.useAgreement") }} <br />
                            </a>
                        </p>
                    </div>
                </div>

                <div class="block_l1">
                    <div class="category_name">
                        <h3 class="category_name_text">
                            {{ $t("message.razdel") }}
                        </h3>
                    </div>

                    <router-link
                        v-for="item in footerRoutes"
                        :key="item.name"
                        :to="
                            item.link === '/tv'
                                ? {
                                      name: item.name,
                                      params: {
                                          lang:
                                              $i18n.locale === 'ru' ? '' : 'uz',
                                      },
                                  }
                                : item.link
                        "
                        class="item_link hover"
                    >
                        {{ $t(`message.${item.name}`) }}
                    </router-link>
                    <router-link
                        class="item_link hover"
                        v-if="isLoggedIn"
                        to="/my/favourites"
                    >
                        {{ $t("message.myMovies") }}
                    </router-link>
                </div>

                <div class="block_l1">
                    <div class="category_name">
                        <h3 class="category_name_text">
                            {{ $t("message.devices") }}
                        </h3>
                    </div>

                    <a
                        href="https://apps.apple.com/app/tvcom-uz/id6479690034"
                        target="_blank"
                        class="item_link hover"
                    >
                        IOS
                    </a>
                    <router-link to="/android" class="item_link hover">
                        Android/Android TV
                    </router-link>
                    <router-link to="/lg" class="item_link hover">
                        LG Smart TV
                    </router-link>
                    <router-link to="/samsung" class="item_link hover">
                        Samsung Smart TV
                    </router-link>
                    <!-- <router-link to="/smart" class="item_link hover">
                        {{ $t("message.ordinaryTv") }}
                    </router-link> -->
                </div>

                <div class="block_l1">
                    <div class="category_name">
                        <h3 class="category_name_text">
                            {{ $t("message.aboutus") }}
                        </h3>
                    </div>
                    <router-link
                        :to="{
                            name: 'blogs',
                            params: { lang: currentLang },
                        }"
                        class="item_link hover"
                    >
                        {{ $t("message.news") }}
                    </router-link>
                    <router-link to="/about" class="item_link hover">
                        {{ $t("message.aboutCompany") }}
                    </router-link>
                    <router-link to="/job" class="item_link hover">
                        {{ $t("message.workin") }}
                    </router-link>
                </div>

                <div class="block_l1">
                    <div class="category_name">
                        <h3 class="category_name_text">
                            {{ $t("message.help") }}
                        </h3>
                    </div>
                    <router-link to="/pay" class="item_link hover">
                        {{ $t("message.payWays") }}
                    </router-link>
                    <router-link to="/cabinet" class="item_link hover">
                        {{ $t("message.tariffs") }}
                    </router-link>
                    <router-link to="/answers" class="item_link hover">
                        {{ $t("message.questionanswer") }}
                    </router-link>
                    <div class="category_name">
                        <a class="item_link hover" href="mailto:info@tvcom.uz"
                            >info@tvcom.uz</a
                        >
                    </div>
                </div>
            </div>
        </div>

        <!-- mobile -->
        <!-- <div class="mob_container">
            <div class="wrapper_mob">
                <div class="container_mob">
                    <router-link class="link" :to="'/channel/'+savedChannel">
                        <img class="old_class" src="../../assets/footer/foot1.svg" alt="Tvcom">
                        <img class="new_class" src="../../assets/footer/foot5.svg" alt="Tvcom">
                    </router-link>
                </div>
                <div class="container_mob">
                    <router-link class="link" to="/newMovies">
                        <img class="old_class" src="../../assets/footer/foot2.svg" alt="Tvcom">
                        <img class="new_class" src="../../assets/footer/foot6.svg" alt="Tvcom">
                    </router-link>
                </div>
                <div class="container_mob">
                    <router-link v-if="isLoggedIn" class="link" to="/interes">
                        <img class="old_class" src="../../assets/footer/foot3.svg" alt="Tvcom">
                        <img class="new_class" src="../../assets/footer/foot7.svg" alt="Tvcom">
                    </router-link>
                    <router-link  v-if="!isLoggedIn" class="link" to="/login">
                        <img class="old_class" src="../../assets/footer/foot3.svg" alt="Tvcom">
                        <img class="new_class" src="../../assets/footer/foot7.svg" alt="Tvcom">
                    </router-link>
                </div>
                <div class="container_mob">
                    <router-link class="link" to="/cabinet">
                        <img class="old_class" src="../../assets/footer/foot4.svg" alt="Tvcom">
                        <img class="new_class" src="../../assets/footer/foot8.svg" alt="Tvcom">
                    </router-link>
                </div>
            </div>
        </div> -->
    </footer>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { routes } from "../router/routes";
const IconFb = defineAsyncComponent(() =>
    import("../components/Icons/footer/facebook.vue")
);
const IconInst = defineAsyncComponent(() =>
    import("../components/Icons/footer/instagram.vue")
);
const IconTg = defineAsyncComponent(() =>
    import("../components/Icons/footer/telegram.vue")
);
const IconOk = defineAsyncComponent(() =>
    import("../components/Icons/footer/odnoklassniki.vue")
);
const ElLink = defineAsyncComponent(() => import("../components/ElLink"));
const Logo = defineAsyncComponent(() => import("./HeaderIcon/Logo.vue"));

export default {
    components: {
        ElLink,
        IconFb,
        IconInst,
        IconTg,
        IconOk,
        Logo,
    },
    data() {
        return {
            footerRoutes: routes.mainNav,
            search_in: null,
            isLoggedIn: false,
            savedChannel: 1,
            count: 0,
            api_key: process.env.MIX_IS_DEV,
        };
    },

    watch: {
        $route(to, from) {
            if (document && localStorage) {
                if (
                    typeof localStorage.getItem("savedChannel") == "string" &&
                    localStorage.getItem("savedChannel") != "undefined"
                ) {
                    this.savedChannel = localStorage.getItem("savedChannel");
                }
            }
        },
    },

    mounted() {
        if (localStorage.getItem("access") === "true") {
            this.isLoggedIn = true;
        }
    },
    computed: {
        currentLang() {
            return this.$i18n.locale === "uz" ? "uz" : "";
        },
    },

    methods: {
        handleTestAccount() {
            if (Number(this.api_key)) {
                this.count += 1;

                if (this.count === 5) {
                    localStorage.setItem("test", true);
                    setTimeout(() => {
                        window.location.reload();
                    }, 100);
                }
            }
        },

        // clickLink(condition) {
        //     if (condition === "movie") {
        //         this.$router.push({
        //             name: "newMovies",
        //             query: {
        //                 season: 0,
        //             },
        //         });
        //     }
        //     if (condition === "serial") {
        //         this.$router.push({
        //             name: "newMovies",
        //             query: {
        //                 season: 1,
        //             },
        //         });
        //     }
        //     if (condition === "kids") {
        //         this.$router.push({
        //             name: "newMovies",
        //             query: {
        //                 gid: 10,
        //             },
        //         });
        //     }
        //     if (condition === "shou") {
        //         this.$router.push({
        //             name: "newMovies",
        //             query: {
        //                 gid: 123,
        //             },
        //         });
        //     }
        // },
    },
};
</script>
<style>
.block_social .el-button .el-button__text {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
<style scoped>
footer {
    margin-top: auto;
    background: #000;
}

.block_icon_img > svg {
    width: 100%;
    height: 100%;
}
.active {
    width: 0;
    transition: 0.2s;
}
.notactive {
    transition: 0.3s;
}

.wrapper {
    display: flex;
    justify-content: center;
    margin: 20px auto;
}
.doc_link {
    color: #8b8b8b;
    /* text-decoration: none;
    text-decoration: underline;
    text-underline-offset: 3px;
    text-decoration-color: transparent;
    transition: 0.3s ease; */
    transition: 0.3s ease;
    position: relative;
    font-size: 11px;
    font-weight: 400;
    line-height: 130%;
}

.doc_link:hover {
    color: #e41a4b;
}
.container {
    width: 90%;
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    margin-top: 20px;
    border-top: 2px solid #e41a4b;
    padding-bottom: 30px;
}
.block_l1 {
    display: flex;
    flex-direction: column;
}
.block_social {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    /* margin-top: 10px; */
}

.block_social .el-button {
    --height: 40px;
    display: block;
}
.block_social .el-button svg {
    width: 24px;
    height: 24px;
}
.block_icon {
    width: 190px;
}

.block_icon > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.phone_text {
    font-size: 32px;
    font-weight: 400;
    white-space: nowrap;
    color: #fff;
    /* letter-spacing: initial; */
    /* width: 100%; */
    /* line-height: 0;*/
    transition: 0.3s ease;
}
.phone_text:hover {
    color: #e41a4b;
}
.block_info > span {
    font-size: 16px;
}

.block_info_text {
    font-family: "Suisse Intl";
    font-weight: 400;
    font-size: 11px;
    color: #bcbcbc;
    margin-top: 6px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 5px;
}
.block_info_text2 {
    font-family: "Suisse Intl";
    font-weight: 400;
    font-size: 10px;
    color: #bcbcbc;
    margin: 0;
    text-align: center;
}
.category_name_text {
    font-family: "Suisse Intl";
    font-size: 18px;
    margin-top: 21px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 5px;
}

.item_link {
    font-family: "Suisse Intl";
    text-decoration: none;
    color: #bcbcbc;
    font-weight: 400;
    font-size: 14px;
    margin: 5px 0;
    cursor: pointer;
}
.mob_container {
    width: 100%;
    display: none;
    margin-top: 7vh;
}

.wrapper_mob {
    width: 100%;
    display: flex;
    position: fixed;
    overflow: hidden;
    bottom: 0;
    background-color: #0a0a0a;
    z-index: 1000000;
    justify-content: space-between;
}
.container_mob {
    width: 100%;
    display: flex;
    justify-content: center;
    background-color: #0a0a0a;
}
.new_class {
    display: none;
}

.link:hover .old_class {
    display: none;
}
.link:hover .new_class {
    display: block;
}
.block_r {
    text-align: end;
}
.block_m {
    text-align: center;
}
.block_social_item {
    background-color: #373737;
    border-radius: 100px;
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.2s;
    /* margin: 0 10px; */
}
.block_social_item:hover {
    background-color: #e41a4b;
}
.block_social_item:hover .active {
    width: initial;
}
.block_social_item:hover .notactive {
    width: 0;
}
.block_l1_super {
    margin-right: 100px;
    max-width: 190px;
    display: flex;
    gap: 15px;
}

@media (max-width: 1024px) {
    .container {
        margin: 0 auto;
    }
    .container_mob {
        width: 80px;
    }
    .mob_container {
        display: flex;
    }
    .wrapper {
        display: none;
    }
}
</style>
